import { render, staticRenderFns } from "./RejectRecord.vue?vue&type=template&id=db4298a2&scoped=true"
import script from "./RejectRecord.vue?vue&type=script&lang=js"
export * from "./RejectRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4298a2",
  null
  
)

export default component.exports